import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {StorageService} from './storage.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private storage: StorageService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    const c: any = this.storage.getItem('premium|auth');
    if (c && c.token && c.user_roles.indexOf('zdravnik') > -1) {
      return true;
    }
    this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
    return false;

    // let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    // return this._userService.verify().map(
    //     data => {
    //         if (data !== null) {
    //             // logged in so return true
    //             return true;
    //         }
    //         // error when verify so redirect to login page with the return url
    //         this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    //         return false;
    //     },
    //     error => {
    //         // error when verify so redirect to login page with the return url
    //         this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    //         return false;
    //     });
  }
}
